<article class="ui-portal-account-card">
  <div class="ui-portal-account-card__main">
    <div class="ui-portal-account-card__heading">
      <ui-avatar
        [label]="avatarLabel()"
        [ariaLabel]="avatarAriaLabel() || name()"
        size="xl"
        shape="circle"
        tone="primary"
      />
      <div class="ui-portal-account-card__intro">
        <h3 class="ui-portal-account-card__name">{{ name() }}</h3>
        <div class="ui-portal-account-card__tags">
          @if (clientCode()) {
            <ui-tag [label]="clientCode()" appearance="outline" color="neutral" />
          }
          <ui-tag [label]="statusLabel()" color="success" />
        </div>
      </div>
      <dl class="ui-portal-account-card__data">
        <div class="ui-portal-account-card__row ui-portal-account-card__row--email">
          <dt>{{ emailLabel() }}</dt>
          <dd>{{ email() }}</dd>
        </div>
        <div class="ui-portal-account-card__row">
          <dt>{{ phoneLabel() }}</dt>
          <dd>{{ phone() }}</dd>
        </div>
      </dl>
    </div>
  </div>
  <div class="ui-portal-account-card__identity">
    <div
      class="ui-portal-account-card__identity-status"
      [class.ui-portal-account-card__identity-status--validated]="identityValidated()"
      [class.ui-portal-account-card__identity-status--pending]="!identityValidated()"
    >
      @if (identityValidated()) {
        <span class="ui-portal-account-card__identity-icon" aria-hidden="true"></span>
        <span class="ui-portal-account-card__identity-mark" aria-hidden="true"></span>
        <span>{{ identityLabel() }}</span>
      } @else {
        <ui-tag [label]="identityLabel()" color="warning" [truncate]="true" />
      }
    </div>
    @if (identityValidated()) {
      <ui-button variant="ghost" size="md" (pressed)="identityClick.emit()">
        Ver
      </ui-button>
    } @else {
      <ui-button variant="primary" size="sm" (pressed)="identityClick.emit()">
        Validar
      </ui-button>
    }
  </div>
</article>
